var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { DocumentLine, DocumentLineGroup } from 'models';
import { plainToInstance } from 'class-transformer';
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Document.prototype.getId = function () {
        return Number(this.id);
    };
    Document.prototype.getName = function () {
        return this.name;
    };
    Document.prototype.setName = function (name) {
        this.name = name;
    };
    Document.prototype.getDocumentLinesCount = function () {
        return Number(this.document_lines_count);
    };
    Document.prototype.getDocumentLines = function () {
        return plainToInstance(DocumentLine, this.document_lines);
    };
    Document.prototype.getDocumentLineGroups = function () {
        return plainToInstance(DocumentLineGroup, this.document_line_groups);
    };
    return Document;
}(Model));
export default Document;
